"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    wrapInScriptTags(scriptId, scriptBody) {
        if (!scriptBody) {
            return '';
        }
        return `\n<script id="${scriptId}">
${scriptBody}
</script>`;
    },
};
